import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../../environments/environment";

@Injectable()
export class ClientSessionIdHttpInterceptor implements HttpInterceptor {

  private static readonly clientSessionId = "" + Math.floor((Math.random() * 1000000000) + 1);
  private static readonly CLIENT_SESSION_ID_HEADER = 'ClientSessionId';

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes(environment.openIdConnect.issuer)) {
      const enrichedHeaders = request.headers.set(ClientSessionIdHttpInterceptor.CLIENT_SESSION_ID_HEADER, ClientSessionIdHttpInterceptor.clientSessionId);
      const enrichedRequest = request.clone({
        headers: enrichedHeaders
      });
      return next.handle(enrichedRequest);
    }
    return next.handle(request);
  }
}
